module.exports = __webpack_public_path__ + "img/LTC-ability-01.a5383f2e.png";